import authService from '@/services/authService';
import DashboardLayout from '@/views/Layout/DashboardLayout.vue';
import AuthLayout from '@/views/Pages/AuthLayout.vue';
// GeneralViews
import NotFound from '@/views/GeneralViews/NotFoundPage.vue';

// Calendar
const Calendar = () => import(/* webpackChunkName: "extra" */ '@/views/Calendar/Calendar.vue');
// Charts
const Charts = () => import(/* webpackChunkName: "dashboard" */ '@/views/Charts.vue');

// Components pages
const Buttons = () => import(/* webpackChunkName: "components" */ '@/views/Components/Buttons.vue');
const Cards = () => import(/* webpackChunkName: "components" */ '@/views/Components/Cards.vue');
const GridSystem = () => import(/* webpackChunkName: "components" */ '@/views/Components/GridSystem.vue');
const Notifications = () => import(/* webpackChunkName: "components" */ '@/views/Components/Notifications.vue');
const Icons = () => import(/* webpackChunkName: "components" */ '@/views/Components/Icons.vue');
const Typography = () => import(/* webpackChunkName: "components" */ '@/views/Components/Typography.vue');

// Dashboard pages
const Dashboard = () => import(/* webpackChunkName: "dashboard" */ '@/views/Dashboard/Dashboard.vue');
const AlternativeDashboard = () => import(/* webpackChunkName: "dashboard" */ '@/views/Dashboard/AlternativeDashboard.vue');
const Widgets = () => import(/* webpackChunkName: "dashboard" */ '@/views/Widgets.vue');

// Forms pages
const FormElements = () => import(/* webpackChunkName: "forms" */ '@/views/Forms/FormElements.vue');
const FormComponents = () => import(/* webpackChunkName: "forms" */ '@/views/Forms/FormComponents.vue');
const FormValidation = () => import(/* webpackChunkName: "forms" */ '@/views/Forms/FormValidation.vue');

// Maps pages
const GoogleMaps = () => import(/* webpackChunkName: "extra" */ '@/views/Maps/GoogleMaps.vue');
const VectorMaps = () => import(/* webpackChunkName: "extra" */ '@/views/Maps/VectorMaps.vue');

// Pages
const User = () => import(/* webpackChunkName: "pages" */ '@/views/Pages/UserProfile.vue');
const Pricing = () => import(/* webpackChunkName: "pages" */ '@/views/Pages/Pricing.vue');
const PricingGitHub = () => import(/* webpackChunkName: "pages" */ '@/views/Pages/Pricing_Github.vue');
const TimeLine = () => import(/* webpackChunkName: "pages" */ '@/views/Pages/TimeLinePage.vue');
const Login = () => import(/* webpackChunkName: "pages" */ '@/views/Pages/Login.vue');
const Home = () => import(/* webpackChunkName: "pages" */ '@/views/Pages/Home.vue');
const Register = () => import(/* webpackChunkName: "pages" */ '@/views/Pages/Register.vue');
const Lock = () => import(/* webpackChunkName: "pages" */ '@/views/Pages/Lock.vue');

// TableList pages
const RegularTables = () => import(/* webpackChunkName: "tables" */ '@/views/Tables/RegularTables.vue');
const SortableTables = () => import(/* webpackChunkName: "tables" */ '@/views/Tables/SortableTables.vue');
const PaginatedTables = () => import(/* webpackChunkName: "tables" */ '@/views/Tables/PaginatedTables.vue');
let componentsMenu = {
  path: '/components',
  component: DashboardLayout,
  redirect: '/components/buttons',
  name: 'Components',
  children: [
    {
      path: 'buttons',
      name: 'Buttons',
      component: Buttons
    },
    {
      path: 'cards',
      name: 'Cards',
      component: Cards
    },
    {
      path: 'grid-system',
      name: 'Grid System',
      component: GridSystem
    },
    {
      path: 'notifications',
      name: 'Notifications',
      component: Notifications
    },
    {
      path: 'icons',
      name: 'Icons',
      component: Icons
    },
    {
      path: 'typography',
      name: 'Typography',
      component: Typography
    }
  ]
};
let formsMenu = {
  path: '/forms',
  component: DashboardLayout,
  redirect: '/forms/elements',
  name: 'Forms',
  children: [
    {
      path: 'elements',
      name: 'Form elements',
      component:  FormElements
    },
    {
      path: 'components',
      name: 'Form components',
      component:  FormComponents
    },
    {
      path: 'validation',
      name: 'Form validation',
      component:  FormValidation
    }
  ]
};

let tablesMenu = {
  path: '/tables',
  component: DashboardLayout,
  redirect: '/tables/regular',
  name: 'Tables menu',
  children: [
    {
      path: 'regular',
      name: 'Tables',
      component: RegularTables
    },
    {
      path: 'sortable',
      name: 'Sortable',
      component: SortableTables
    },
    {
      path: 'paginated',
      name: 'Paginated Tables',
      component: PaginatedTables
    }
  ]
};

let mapsMenu = {
  path: '/maps',
  component: DashboardLayout,
  name: 'Maps',
  redirect: '/maps/google',
  children: [
    {
      path: 'google',
      name: 'Google Maps',
      component: GoogleMaps
    },
    {
      path: 'vector',
      name: 'Vector Map',
      component: VectorMaps
    }
  ]
};

let pagesMenu = {
  path: '/pages',
  component: DashboardLayout,
  name: 'Pages',
  redirect: '/pages/user',
  children: [
    {
      path: 'user',
      name: 'User Page',
      component: User
    },
    {
      path: 'timeline',
      name: 'Timeline Page',
      component: TimeLine
    }
  ]
};

let authPages = {
  path: '/',
  component: AuthLayout,
  name: 'Authentication',
  children: [
    {
      path: '/home',
      name: 'HomeAuth',
      component: Home,
      meta: {
        noBodyBackground: true
      }
    },
    {
      path: '/login1',
      name: 'Login1',
      component: Login
    },
    {
      path: '/register',
      name: 'Register',
      component: Register
    },
    {path: '/price',name: 'Price', redirect: '/pricing'},
    {path: '/pricing',name: 'Pricing',component: Pricing},
    {path: '/devops-integration-plans',name: 'Pricing-DevOps',component: Pricing},
    {path: '/pricing-github',name: 'Price-GitHub',component: PricingGitHub},
    {
      path: '/pro',
      name: 'Pro',
      component:()=>import('@/views/Pages/Pro.vue')
    },
    {
      path: '/azure-devops-integration-pro',
      name: 'ADOPro',
      component:()=>import('@/views/Pages/Pro.vue')
    },
    {
      path: '/contact',
      name: 'Contact',
      component:()=>import('@/views/Pages/Contact.vue')
    },
    //{path: 'request-a-demo',name: 'request-a-demo',component:()=>import('@/views/Pages/request-a-demo/request-a-demo.vue')},
    {path: 'login',name: 'Login',component:()=>import('@/views/Pages/login/login.vue')},
    {path: 'forgot-password',component:()=>import('@/views/Pages/forgot-password/forgot-password.vue')},
    {path: 'reset-password/:token/:userId',component:()=>import('@/views/Pages/reset-password/reset-password.vue')},
    // {
    //   path: '/privacy',
    //   name: 'Privacy',
    //   component:()=>import('@/views/Pages/Privacy_Old.vue')
    // },
    {
      path: '/privacy',
      name: 'Privacy',
      component:()=>import('@/views/Pages/Privacy.vue')
    },
    // {
    //   path: '/terms',
    //   name: 'Terms',
    //   component:()=>import('@/views/Pages/Terms_Old.vue')
    // },
    {
      path: '/terms',
      name: 'Terms',
      component:()=>import('@/views/Pages/Terms.vue')
    },
    {
      path: '/features',
      name: 'Features',
      component:()=>import('@/views/Pages/Features.vue')
    },
    {
      path: '/services',
      name: 'Services',
      component:()=>import('@/views/Pages/Services.vue')
    },
    {
      path: '/faq',
      name: 'FAQ',
      component:()=>import('@/views/Pages/FAQ.vue')
    },
    {
      path: '/docs/:appType?',
      name: 'Docs',
      component:()=>import('@/views/Pages/Documentation.vue')
    },
    {
      path: '/documentation/:appType?',
      name: 'Documentation',
      component:()=>import('@/views/Pages/Documentation.vue')
    },
    { path: '/apps/support/azure-devops-integration', component: () => import('@/views/Pages/azure-devops-apps/installation-redirect.vue') },
    {path: '/apps/support/azure-devops-integration-pro',component:()=>import('@/views/Pages/azure-devops-apps/installation-redirect.vue')},
    // {
    //   path: '/apps',
    //   name: 'Apps',
    //   component:()=>import('@/views/Pages/Apps.vue')
    // },
    {path: 'apps',component:()=>import('@/views/Pages/devops-apps/apps.vue'),},
    {path: '/apps/azure-devops/integrations/zendesk',component:()=>import('@/views/Pages/devops-apps/zendesk.vue')},
    {path: '/apps/azure-devops/integrations/freshdesk',component:()=>import('@/views/Pages/devops-apps/freshdesk.vue')},
    { path: '/apps/azure-devops/integrations/freshservice', component: () => import('@/views/Pages/devops-apps/freshservice.vue') },
    {path: '/apps/azure-devops/integrations/monday',component:()=>import('@/views/Pages/devops-apps/monday.vue')},

    {path: '/apps/zendesk_azure_devops',component:()=>import('@/views/Pages/azure-devops-apps/zendesk.vue')},
    {path: '/apps/freshdesk_azure_devops',component:()=>import('@/views/Pages/azure-devops-apps/freshdesk.vue')},
    { path: '/apps/freshservice_azure_devops', component: () => import('@/views/Pages/azure-devops-apps/freshservice.vue') },
    {path: '/apps/monday_azure_devops',component:()=>import('@/views/Pages/azure-devops-apps/monday.vue')},

    {path: 'apps/zendesk-azure-devops-integration',component:()=>import('@/views/Pages/devops-apps/zendesk.vue')},
    {path: 'apps/freshdesk-azure-devops-integration',component:()=>import('@/views/Pages/devops-apps/freshdesk.vue')},
    {path: 'apps/freshservice-azure-devops-integration',component:()=>import('@/views/Pages/devops-apps/freshservice.vue')},
    {path: 'apps/monday-azure-devops-integration',component:()=>import('@/views/Pages/devops-apps/monday.vue')},
    //marketting urls

    {path: '/apps/zendesk_ado',component:()=>import('@/views/Pages/azure-devops-apps/zendesk.vue')},
    {path: '/apps/freshdesk_ado',component:()=>import('@/views/Pages/azure-devops-apps/freshdesk.vue')},
    { path: '/apps/freshservice_ado', component: () => import('@/views/Pages/azure-devops-apps/freshservice.vue') },
    {path: '/apps/monday_ado', component: () => import('@/views/Pages/azure-devops-apps/monday.vue') },
    
    {path: '/apps/zendesk_vsts',component:()=>import('@/views/Pages/azure-devops-apps/zendesk.vue')},
    {path: '/apps/freshdesk_vsts',component:()=>import('@/views/Pages/azure-devops-apps/freshdesk.vue')},
    { path: '/apps/freshservice_vsts', component: () => import('@/views/Pages/azure-devops-apps/freshservice.vue') },
    {path: '/apps/monday_vsts',component:()=>import('@/views/Pages/azure-devops-apps/monday.vue')},
    
    {path: 'apps/zendesk-ado-integration',component:()=>import('@/views/Pages/devops-apps/zendesk.vue')},
    {path: 'apps/freshdesk-ado-integration',component:()=>import('@/views/Pages/devops-apps/freshdesk.vue')},
    { path: 'apps/freshservice-ado-integration', component: () => import('@/views/Pages/devops-apps/freshservice.vue') },
    {path: 'apps/monday-ado-integration', component: () => import('@/views/Pages/devops-apps/monday.vue') },
    
    {path: '/azure-devops-connector',component:()=>import('@/views/Pages/Azure-DevOps.vue')},
    {path: '/azure-devops',component:()=>import('@/views/Pages/Azure-DevOps.vue')},
    {path: '/azure-devops-integration',component:()=>import('@/views/Pages/Azure-DevOps.vue')},
    
    {path: '/zendesk-azure-devops-connector',component:()=>import('@/views/Pages/devops-apps/zendesk.vue')},
    {path: '/freshdesk-azure-devops-connector',component:()=>import('@/views/Pages/devops-apps/freshdesk.vue')},
    { path: '/freshservice-azure-devops-connector', component: () => import('@/views/Pages/devops-apps/freshservice.vue') },
    {path: '/monday-azure-devops-connector',component:()=>import('@/views/Pages/devops-apps/monday.vue')},

    {path: '/connect-zendesk-azure-devops',component:()=>import('@/views/Pages/devops-apps/zendesk.vue')},
    {path: '/connect-freshdesk-azure-devops',component:()=>import('@/views/Pages/devops-apps/freshdesk.vue')},
    { path: '/connect-freshservice-azure-devops', component: () => import('@/views/Pages/devops-apps/freshservice.vue') },
    {path: '/connect-monday-azure-devops', component: () => import('@/views/Pages/devops-apps/monday.vue') },
    
    {path: '/connect-zendesk-ado',component:()=>import('@/views/Pages/devops-apps/zendesk.vue')},
    {path: '/connect-freshdesk-ado',component:()=>import('@/views/Pages/devops-apps/freshdesk.vue')},
    { path: '/connect-freshservice-ado', component: () => import('@/views/Pages/devops-apps/freshservice.vue') },
    {path: '/connect-monday-ado',component:()=>import('@/views/Pages/devops-apps/monday.vue')},

    {path: '/zendesk-vsts-connector',component:()=>import('@/views/Pages/devops-apps/zendesk.vue')},
    {path: '/freshdesk-vsts-connector',component:()=>import('@/views/Pages/devops-apps/freshdesk.vue')},
    { path: '/freshservice-vsts-connector', component: () => import('@/views/Pages/devops-apps/freshservice.vue') },
    {path: '/monday-vsts-connector',component:()=>import('@/views/Pages/devops-apps/monday.vue')},

    {path: '/zendesk-ado-connector',component:()=>import('@/views/Pages/devops-apps/zendesk.vue')},
    {path: '/freshdesk-ado-connector',component:()=>import('@/views/Pages/devops-apps/freshdesk.vue')},
    { path: '/freshservice-ado-connector', component: () => import('@/views/Pages/devops-apps/freshservice.vue') },
    {path: '/monday-ado-connector',component:()=>import('@/views/Pages/devops-apps/monday.vue')},

    //change
    {path: '/apps/change-management-devops-integration',component:()=>import('@/views/Pages/devops-apps/freshservice-change.vue')},
    {path: '/apps/change-management-ado-integration',component:()=>import('@/views/Pages/devops-apps/freshservice-change.vue')},
    { path: '/it-service-management/change-management-devops-connector', component: () => import('@/views/Pages/devops-apps/freshservice-change.vue') },
    {path: '/it-service-management/change-management-ado-connector',component:()=>import('@/views/Pages/devops-apps/freshservice-change.vue')},
    { path: '/it-service-management/change-management-azure-devops-integration', component: () => import('@/views/Pages/devops-apps/freshservice-change.vue') },
    {path: '/it-service-management/change-management-ado-integration',component:()=>import('@/views/Pages/devops-apps/freshservice-change.vue')},
    {path: '/it-service-management/change-management-azure-devops-connector',component:()=>import('@/views/Pages/devops-apps/freshservice-change.vue')},
    {path: '/it-service-management/change-management-vsts-connector',component:()=>import('@/views/Pages/devops-apps/freshservice-change.vue')},
    
    {path: '/it-service-management/change-management-devops-integration',component:()=>import('@/views/Pages/azure-devops-apps/freshservice-change.vue')},
    
    //marketting ends

    {
      path: '/installation',
      name: 'installation',
      component:()=>import('@/views/Pages/Installation.vue')
    },
    {
      path: '/lock',
      name: 'Lock',
      component: Lock
    },
    { path: '*', component: NotFound }
  ]
};

const routes = [
  {
    path: '/',
    redirect: '/home',
    name: 'Home'
  },
  componentsMenu,
  formsMenu,
  tablesMenu,
  mapsMenu,
  pagesMenu,
  {path: '/admin',beforeEnter:authService.requireAuth, component:DashboardLayout,
		children: [
      { path: 'devops-customers', component: () => import('@/views/admin/devops-customers/devops-customers.vue') },
      {path: 'monday-devops-customers',component:()=>import('@/views/admin/monday-devops-customers/monday-devops-customers.vue')},
      {path: 'github-customers',component:()=>import('@/views/admin/github-customers/github-customers.vue')},
			{path: 'app-customers/:appName',component:()=>import('@/views/admin/app-customers/app-customers.vue')},
			{path: 'customers',component:()=>import('@/views/admin/customers/customers.vue')},
			{path: 'tickets/:userId/:requestType',component:()=>import('@/views/admin/tickets/tickets.vue')},
			{path: 'payments',component:()=>import('@/views/admin/payments/payments.vue')},
			{path: 'job-log',component:()=>import('@/views/admin/job-log-report/job-log-report.vue')},
		]
	},
  {path: '/el',redirect:'/app',component:()=>import('@/views/Layout/EmptyLayout.vue'),
		children: [
			  //sync set up
      { path: 'sync-setup/devops/:requestType/:userId/:appId/:installationId/:userEmail/:account', component: () => import('@/views/sync-setup/devops/sync-setup.vue'), },
      { path: 'sync-setup/github/:requestType/:userId/:appId/:installationId/:userEmail/:account', component: () => import('@/views/sync-setup/github/sync-setup.vue'), },
      { path: 'sync-setup/:requestType/:userId/:appId/:installationId/:userEmail/:account', component: () => import('@/views/sync-setup/devops/sync-setup.vue'), },
    ]
  },
	{path: '/zendesk-devops',redirect:'/app',component:()=>import('@/views/Layout/zendesk-devops.vue'),
		children: [
			{path: 'app',alias: "/",component: ()=>import('@/views/zendesk-devops/index/index.vue')},
			{ path: 'authenticate/:userId?/:devOpsUrl?', component: () => import('@/views/zendesk-devops/authenticate/authenticate.vue') },
			{path: 'configure/:zdTicketId?',component: ()=>import('@/views/zendesk-devops/configure/configure.vue')},
			{path: 'configure-app/:zdTicketId?',component: ()=>import('@/views/zendesk-devops/configure-app/configure-app.vue')},
			{path: 'create-work-item/:zdTicketId?',component: ()=>import('@/views/zendesk-devops/create-work-item/create-work-item.vue')},
			{path: 'search-work-item/:zdTicketId?',component: ()=>import('@/views/zendesk-devops/search-work-item/search-work-item.vue')},
			{path: 'search-work-item_old',component: ()=>import('@/views/zendesk-devops/search-work-item_old/search-work-item.vue')},
			{path: 'link-work-item/:zdTicketId?',component: ()=>import('@/views/zendesk-devops/link-work-item/link-work-item.vue')},
			{path: 'notify-work-item/:zdTicketId?',component: ()=>import('@/views/zendesk-devops/notify-work-item/notify-work-item.vue')},
			{path: 'work-item-log/:zdTicketId?',component: ()=>import('@/views/zendesk-devops/work-item-log/work-item-log.vue')},
			{path: 'linked-tickets/:zdTicketId?',component: ()=>import('@/views/zendesk-devops/linked-tickets/linked-tickets.vue')},
			{path: 'enable-syncing',component: ()=>import('@/views/zendesk-devops/enable-syncing/enable-syncing.vue')},
			{path: 'confirm-dialog/:zdTicketId?',component: ()=>import('@/views/confirm-dialog/confirm-dialog.vue')},

			//custom
			{path: 'custom/devopsintegrationio/create-work-item/:zdTicketId?',component: ()=>import('@/views/zendesk-devops/custom/devopsintegrationio/create-work-item.vue')},
			{path: 'custom/powermatrix/create-work-item/:zdTicketId?',component: ()=>import('@/views/zendesk-devops/custom/powermatrix/create-work-item.vue')},
			{path: 'custom/limeade/create-work-item/:zdTicketId?',component: ()=>import('@/views/zendesk-devops/custom/limeade/create-work-item.vue')},
      {path: 'custom/novopathllc/create-work-item/:zdTicketId?',component: ()=>import('@/views/zendesk-devops/custom/novopathllc/create-work-item.vue')},
      {path: 'custom/oncologyanalytics/create-work-item/:zdTicketId?',component: ()=>import('@/views/zendesk-devops/custom/oncologyanalytics/create-work-item.vue')},
      {path: 'custom/castlequick/create-work-item/:zdTicketId?',component: ()=>import('@/views/zendesk-devops/custom/castlequick/create-work-item.vue')},
      {path: 'custom/engagetfs/create-work-item/:zdTicketId?',component: ()=>import('@/views/zendesk-devops/custom/engagetfs/create-work-item.vue')},
      {path: 'custom/hubb/create-work-item/:zdTicketId?',component: ()=>import('@/views/zendesk-devops/custom/hubb/create-work-item.vue')},
      {path: 'custom/epmpartners/create-work-item/:zdTicketId?',component: ()=>import('@/views/zendesk-devops/custom/epmpartners/create-work-item.vue')},
      {path: 'custom/datalinksoftware/create-work-item/:zdTicketId?',component: ()=>import('@/views/zendesk-devops/custom/datalinksoftware/create-work-item.vue')},
      {path: 'custom/nautilus-org/create-work-item/:zdTicketId?',component: ()=>import('@/views/zendesk-devops/custom/nautilus-org/create-work-item.vue')},
      {path: 'custom/uwa-dev/create-work-item/:zdTicketId?',component: ()=>import('@/views/zendesk-devops/custom/uwa-dev/create-work-item.vue')},
      {path: 'custom/upkalidea/create-work-item/:zdTicketId?',component: ()=>import('@/views/zendesk-devops/custom/upkalidea/create-work-item.vue')},
      {path: 'custom/smartr365/create-work-item/:zdTicketId?', component: () => import('@/views/zendesk-devops/custom/smartr365/create-work-item.vue') },
      {path: 'custom/loc-devops/create-work-item/:zdTicketId?',component: ()=>import('@/views/zendesk-devops/custom/loc-devops/create-work-item.vue')},
      {path: 'custom/toyotavso/create-work-item/:zdTicketId?',component: ()=>import('@/views/zendesk-devops/custom/toyotavso/create-work-item.vue')},
      {path: 'custom/upshop/create-work-item/:zdTicketId?',component: ()=>import('@/views/zendesk-devops/custom/upshop/create-work-item.vue')},
      { path: 'custom/dnvimatis/create-work-item/:zdTicketId?', component: () => import('@/views/zendesk-devops/custom/dnvimatis/create-work-item.vue') },
      { path: 'custom/tvsscs/create-work-item/:zdTicketId?',component: ()=>import('@/views/zendesk-devops/custom/tvsscs/create-work-item.vue')},
      { path: 'custom/montagetalent/create-work-item/:zdTicketId?', component: () => import('@/views/zendesk-devops/custom/montagetalent/create-work-item.vue') },
      { path: 'custom/echo-project/create-work-item/:zdTicketId?', component: () => import('@/views/zendesk-devops/custom/echo-project/create-work-item.vue') },
      { path: 'custom/intelligentcomms/create-work-item/:zdTicketId?', component: () => import('@/views/zendesk-devops/custom/intelligentcomms/create-work-item.vue') },
      { path: 'custom/tritrials/create-work-item/:zdTicketId?', component: () => import('@/views/zendesk-devops/custom/tritrials/create-work-item.vue') },
      { path: 'custom/dealer-fx/create-work-item/:zdTicketId?', component: () => import('@/views/zendesk-devops/custom/dealer-fx/create-work-item.vue') },
      { path: 'custom/liviniti/create-work-item/:zdTicketId?', component: () => import('@/views/zendesk-devops/custom/liviniti/create-work-item.vue') },
      { path: 'custom/accreditbizops/create-work-item/:zdTicketId?', component: () => import('@/views/zendesk-devops/custom/accreditbizops/create-work-item.vue') },
      { path: 'custom/iqul/create-work-item/:zdTicketId?', component: () => import('@/views/zendesk-devops/custom/iqul/create-work-item.vue') },
      {path: 'custom/rivalitinc/create-work-item/:zdTicketId?',component: ()=>import('@/views/zendesk-devops/custom/rivalitinc/create-work-item.vue')},

      {path: 'custom/kneatorg/create-work-item/:zdTicketId?',component: ()=>import('@/views/zendesk-devops/custom/kneatorg/create-work-item.vue')},
      {path: 'custom/kneatorg/linked-tickets/:zdTicketId?',component: ()=>import('@/views/zendesk-devops/custom/kneatorg/linked-tickets.vue')},
      
      { path: 'custom/personifycorp/create-work-item/:zdTicketId?', component: () => import('@/views/zendesk-devops/custom/personifycorp/create-work-item.vue') },
      { path: 'custom/personifycorp/work-item-log/:zdTicketId?',component: ()=>import('@/views/zendesk-devops/custom/personifycorp/work-item-log.vue')},

		]
	},
  {path: '/monday-devops',redirect:'/app',component:()=>import('@/views/Layout/monday-devops.vue'),
    children: [
      {path: 'oauth/callback/:mdItemId?',component: ()=>import('@/views/monday-devops/oauth_callback/oauth_callback.vue')},
      {path: 'app', alias: "/", component: () => import('@/views/monday-devops/index/index.vue') },
      {path: 'authenticate_token/:appId/:installationId/:hdBoardId?/:hdItemId?/:userId?/:devOpsUrl?', component: () => import('@/views/monday-devops/authenticate_token/authenticate_token.vue') },
			{path: 'authenticate_outh2/:appId/:installationId/:hdBoardId?/:hdItemId?/:userId?/:devOpsUrl?/:client_id?', component: () => import('@/views/monday-devops/authenticate_outh2/authenticate_outh2.vue') },
			{path: 'configure/:appId/:installationId/:hdBoardId?/:hdItemId?',component: ()=>import('@/views/monday-devops/configure/configure.vue')},
			{path: 'configure-app/:appId/:installationId/:hdBoardId?/:hdItemId?',component: ()=>import('@/views/monday-devops/configure-app/configure-app.vue')},
			{path: 'create-work-item/:appId/:installationId/:hdBoardId?/:hdItemId?',component: ()=>import('@/views/monday-devops/create-work-item/create-work-item.vue')},
			{path: 'search-work-item/:appId/:installationId/:hdBoardId?/:hdItemId?',component: ()=>import('@/views/monday-devops/search-work-item/search-work-item.vue')},
			{path: 'link-work-item/:appId/:installationId/:hdBoardId?/:hdItemId?',component: ()=>import('@/views/monday-devops/link-work-item/link-work-item.vue')},
			{path: 'notify-work-item/:appId/:installationId/:hdBoardId?/:hdItemId?',component: ()=>import('@/views/monday-devops/notify-work-item/notify-work-item.vue')},
			{path: 'work-item-log/:appId/:installationId/:hdBoardId?/:hdItemId?',component: ()=>import('@/views/monday-devops/work-item-log/work-item-log.vue')},
			{path: 'linked-items/:appId/:installationId/:hdBoardId?/:hdItemId?',component: ()=>import('@/views/monday-devops/linked-items/linked-items.vue')},
			{path: 'enable-syncing/:appId/:installationId',component: ()=>import('@/views/monday-devops/enable-syncing/enable-syncing.vue')},
			{path: 'confirm-dialog/:appId/:installationId/:hdBoardId?/:hdItemId?',component: ()=>import('@/views/confirm-dialog-monday/confirm-dialog-monday.vue')},

			//custom
      { path: 'custom/devopsintegrationio/create-work-item/:appId/:installationId/:hdBoardId?/:hdItemId?', component: () => import('@/views/monday-devops/custom/devopsintegrationio/create-work-item.vue') },
      
		]
	},
	{path: '/zendesk-jira',redirect:'/app',component:()=>import('@/views/Layout/zendesk-jira.vue'),
		children: [
			{path: 'app',alias: "/",component: ()=>import('@/views/zendesk-jira/index/index.vue')},
			{path: 'authenticate/:userId?/:jiraUrl?',component: ()=>import('@/views/zendesk-jira/authenticate/authenticate.vue')},
			{path: 'configure',component: ()=>import('@/views/zendesk-jira/configure/configure.vue')},
			{path: 'configure-app',component: ()=>import('@/views/zendesk-jira/configure-app/configure-app.vue')},
			{path: 'create-issue',component: ()=>import('@/views/zendesk-jira/create-issue/create-issue.vue')},
			{path: 'search-issue',component: ()=>import('@/views/zendesk-jira/search-issue/search-issue.vue')},
			{path: 'link-issue',component: ()=>import('@/views/zendesk-jira/link-issue/link-issue.vue')},
			{path: 'notify-issue',component: ()=>import('@/views/zendesk-jira/notify-issue/notify-issue.vue')},
			{path: 'issue-log',component: ()=>import('@/views/zendesk-jira/issue-log/issue-log.vue')},
			{path: 'linked-tickets',component: ()=>import('@/views/zendesk-jira/linked-tickets/linked-tickets.vue')},
			{path: 'enable-syncing',component: ()=>import('@/views/zendesk-jira/enable-syncing/enable-syncing.vue')},
			{path: 'confirm-dialog',component: ()=>import('@/views/confirm-dialog/confirm-dialog.vue')},

			//custom
			{path: 'custom/jiraintegrationio/create-issue',component: ()=>import('@/views/zendesk-jira/custom/jiraintegrationio/create-issue.vue')},
		]
	},
	{path: '/zendesk-github',redirect:'/app',component:()=>import('@/views/Layout/zendesk-github.vue'),
		children: [
			{path: 'app',alias: "/",component: ()=>import('@/views/zendesk-github/index/index.vue')},
			{path: 'authenticate/:userId?/:devOpsUrl?',component: ()=>import('@/views/zendesk-github/authenticate/authenticate.vue')},
			{path: 'configure/:zdTicketId?',component: ()=>import('@/views/zendesk-github/configure/configure.vue')},
			{path: 'create-issue/:zdTicketId?',component: ()=>import('@/views/zendesk-github/create-issue/create-issue.vue')},
			{path: 'link-issue/:zdTicketId?',component: ()=>import('@/views/zendesk-github/link-issue/link-issue.vue')},
			{path: 'notify-issue/:zdTicketId?',component: ()=>import('@/views/zendesk-github/notify-issue/notify-issue.vue')},
			{path: 'issue-log/:zdTicketId?',component: ()=>import('@/views/zendesk-github/issue-log/issue-log.vue')},
			{path: 'linked-tickets/:zdTicketId?',component: ()=>import('@/views/zendesk-github/linked-tickets/linked-tickets.vue')},
			{path: 'enable-syncing',component: ()=>import('@/views/zendesk-github/enable-syncing/enable-syncing.vue')},
			{path: 'confirm-dialog/:zdTicketId?',component: ()=>import('@/views/confirm-dialog/confirm-dialog.vue')},

			//custom
			{path: 'custom/devopsintegrationio/create-issue/:zdTicketId?',component: ()=>import('@/views/zendesk-github/custom/devopsintegrationio/create-issue.vue')},
      {path: 'custom/zapper-fi/create-issue/:zdTicketId?',component: ()=>import('@/views/zendesk-github/custom/zapper-fi/create-issue.vue')},
      {path: 'custom/normalyze/create-issue/:zdTicketId?',component: ()=>import('@/views/zendesk-github/custom/normalyze/create-issue.vue')},
		]
	},
	{path: '/zendesk-asana',redirect:'/app',component:()=>import('@/views/Layout/zendesk-asana.vue'),
		children: [
			{path: 'app',alias: "/",component: ()=>import('@/views/zendesk-asana/index/index.vue')},
			{path: 'authenticate/:userId?/:devOpsUrl?',component: ()=>import('@/views/zendesk-asana/authenticate/authenticate.vue')},
			{path: 'configure',component: ()=>import('@/views/zendesk-asana/configure/configure.vue')},
			{path: 'create-task',component: ()=>import('@/views/zendesk-asana/create-task/create-task.vue')},
			{path: 'link-task',component: ()=>import('@/views/zendesk-asana/link-task/link-task.vue')},
			{path: 'notify-task',component: ()=>import('@/views/zendesk-asana/notify-task/notify-task.vue')},
			{path: 'task-log',component: ()=>import('@/views/zendesk-asana/task-log/task-log.vue')},
			{path: 'linked-tickets',component: ()=>import('@/views/zendesk-asana/linked-tickets/linked-tickets.vue')},
			{path: 'enable-syncing',component: ()=>import('@/views/zendesk-asana/enable-syncing/enable-syncing.vue')},
			{path: 'confirm-dialog',component: ()=>import('@/views/confirm-dialog/confirm-dialog.vue')},

			//custom
			//{path: 'custom/devopsintegrationio/create-work-item',component: ()=>import('@/views/zendesk-github/custom/devopsintegrationio/create-work-item.vue')},
		]
	},
  {
    path: '/',
    component: DashboardLayout,
    redirect: '/dashboard',
    name: 'Dashboard layout',
    children: [
      {
        path: 'dashboard',
        name: 'Dashboard',
        component: Dashboard
      },
      {
        path: 'alternative',
        name: 'Alternative',
        component: AlternativeDashboard,
        meta: {
          navbarType: 'light'
        }
      },
      {
        path: 'calendar',
        name: 'Calendar',
        component: Calendar
      },
      {
        path: 'charts',
        name: 'Charts',
        component: Charts
      },
      {
        path: 'widgets',
        name: 'Widgets',
        component: Widgets
      }
    ]
  },
  authPages,
	//{path: '/:notFound(.*)',component:()=>import('@/views/path-not-found-404/path-not-found-404.vue')},
	{path: '*',from:'*',redirect:'/404'}
];

export default routes;
